import store from "@service/store";
import { NavigationGuardNext, Route } from "vue-router";

export const checkRestrictedPartner = (to: Route, next: NavigationGuardNext) => {
    const isRestrictedPartner = store.getters["events/isRestrictedPartner"];

    if (isRestrictedPartner && to.name === "Home") {
        next({ name: "Partners", params: { ...to.params, schemaId: "Exhibition" } });
        return true;
    }

    return false;
}